export const RP_STATUS = {
  STATUS_NOT_DONE: 0,
  STATUS_DONE: 1,
  STATUS_PROCESSING: 2,
  STATUS_FAILED: 3,
  STATUS_DISABLED: 4,
}

export const DEFAULT_DPI = 72;

export const RENDER_IMAGE_TYPE = {
  STANDARD: '1',
  FILMIC: '2',
  COLOR: '3',
}

export const PASS = {
  STANDARD: '1',
  FILMIC: '2',
  COLOR: '3',
  ORIGINAL: '4',
  POST_EDIT: '5',
};

export const IMAGE_TYPE = {
  STANDARD: 'standard',
  FILMIC: 'filmic',
  COLOR: 'color pass',
  POST_EDIT: 'post edit',
  ORIGINAL: 'original',
};

export const IMAGE_VARIATION_TYPE = {
  [PASS.STANDARD]: 'Standard',
  [PASS.FILMIC]: 'Filmic',
  [PASS.COLOR]: 'Color',
};